import React from "react";

const List = (props) => {
    const items = props.list.map((text, index) => {
        return <li key={`notification-bar-item_${index}`}>{text}</li>;
    });

    return <ul>{items}</ul>;
};

export default List;
